import {
  Box,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableContainer,
  TableRow,
  Typography
} from '@mui/material';

const LegendLevels = ({ assessmentArea }) => {
  return (
    <TableContainer className=' flex flex-col  max-w-350px min-w-350px z-10' component={Box}>
      <Table>
        <TableHead className='sticky top-0px z-10'>
          <TableRow>
            <TableCell
              colSpan={2}
              style={{
                outline: '1px solid var(--muted)'
              }}
            >
              <div className='flex gap-2 items-center'>
                <Typography variant='subtitle2' className='font-bold text-lg text-center'>
                  {assessmentArea?.code || <Skeleton variant='text' width={100} />} -
                </Typography>
                <Typography variant='subtitle2' className='font-bold text-lg text-center'>
                  {assessmentArea?.name || <Skeleton variant='text' width={200} />}
                </Typography>
              </div>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              colSpan={2}
              style={{
                outline: '1px solid var(--muted)'
              }}
            >
              Levels
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              style={{
                outline: '1px solid var(--muted)'
              }}
            >
              code
            </TableCell>
            <TableCell
              style={{
                outline: '1px solid var(--muted)'
              }}
            >
              description
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {assessmentArea?.levels?.length ? (
            assessmentArea.levels.map((level) => (
              <TableRow key={level._id}>
                <TableCell
                  style={{
                    outline: '1px solid var(--muted)'
                  }}
                  width={50}
                  align='right'
                >
                  {level.code}
                </TableCell>
                <TableCell
                  style={{
                    outline: '1px solid var(--muted)'
                  }}
                >
                  {level.definition || '-'}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={2} className='text-center'>
                No levels defined
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default LegendLevels;
